import { PlanTypeEnum as PlanType } from "../../types";

export const getSelectedPlanUrl = (
  planType: string,
  selectedCurrencyName: string
) => {
  return planType === PlanType.Team
    ? `/sign-up/?from=logged-out-pricing-page&next=/app/team-account-setup&currency=${selectedCurrencyName}`
    : `/sign-up?from=logged-out-pricing-page&currency=${selectedCurrencyName}`;
};
